import settingsService from '../services';
import { Role, UserRolesInput } from '../types/members-types';
import { updateUserRoles } from '../store-actions/update-user-roles-store-actions';

export const addUserRolesAction = async (
  userRolesInput: UserRolesInput,
): Promise<void> => {
  const userRoles: Role[] = await settingsService.addUserRoles.execute(
    userRolesInput,
  );
  return updateUserRoles(userRolesInput.userId, userRoles);
};

export const deleteUserRolesAction = async (
  userRolesInput: UserRolesInput,
): Promise<void> => {
  const userRoles: Role[] = await settingsService.deleteUserRoles.execute(
    userRolesInput,
  );
  return updateUserRoles(userRolesInput.userId, userRoles);
};
